module.exports = __webpack_public_path__ + "static/media/monicaAnderson.a9e12e78.png";